import { CTA, Layout, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { PriceEstimateWithServicePlanPageViewProps } from './PriceEstimateWithServicePlanPageViewProps';
import { priceEstimateWithServicePlanPageFormSchema } from './PriceEstimateWithServicePlanPageFormSchema';
import { Form } from '../../modules/forms/Form';
import { CheckboxField } from '../../modules/forms/fields/CheckboxField';

const StyledServiceDescription = styled(Text)`
  margin-top: ${(props) => props.theme.size.dynamic0100};
`;
const StyledValueWithUnit = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.static200};
  margin: ${(props) => props.theme.size.static400} 0;

  & div {
    display: flex;
    align-items: flex-end;
    gap: ${(props) => props.theme.size.static150};
  }
`;
const StyledTermsAndConditionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export function PriceEstimateWithServicePlanPageVwView({
  initialFormData,
  formRef,
  serviceRequest,
  vehicleServiceHistory,
  onTermsAndConditionsClick,
}: PriceEstimateWithServicePlanPageViewProps): ReactElement {
  return (
    <Layout allowOverflowingContent>
      <Text appearance={TokenTextAppearance.headline300} bold>
        {serviceRequest.serviceType.name}
      </Text>
      <StyledServiceDescription appearance={TokenTextAppearance.copy200}>
        {vehicleServiceHistory.serviceDescription}
      </StyledServiceDescription>
      <Form defaultValues={initialFormData} ref={formRef} schema={priceEstimateWithServicePlanPageFormSchema}>
        <StyledValueWithUnit>
          <Text appearance={TokenTextAppearance.copy200}>Total cost of the service</Text>
          <Text appearance={TokenTextAppearance.headline400} bold>
            40
            <Text appearance={TokenTextAppearance.headline200} bold={false}>
              $
            </Text>
          </Text>
        </StyledValueWithUnit>
        <CheckboxField
          name="termsAndConditionsAccepted"
          label={
            <StyledTermsAndConditionsWrapper>
              <Text>
                I accept the{' '}
                <CTA tag="a" emphasis="tertiary" onClick={onTermsAndConditionsClick}>
                  terms and conditions
                </CTA>
              </Text>
            </StyledTermsAndConditionsWrapper>
          }
        />
      </Form>
    </Layout>
  );
}
